export const MessageContent = () => {
  return (
    <div className="bg-primary/5 p-6 rounded-lg mb-6 shadow-sm">
      <p className="text-lg font-medium text-primary mb-4">
        Ce site est conçu par des tiots d'chés nous… mais il est fait pour toute la France !
      </p>
      <div className="space-y-3 text-gray-700">
        <p>
          Partagez-le à vos voisins, à tatie Ginette et même à Kevin (même s'il est un peu relou),
          sans oublier votre collègue parisien qui pense que l'Aisne, c'est "vers Reims, non ?"
        </p>
        <p className="mt-4 text-primary/90 font-medium">
          Parce qu'ici, on ne fait pas briller que les clochers de Laon…
          On fait briller vos bonnes adresses, vos événements, et votre savoir-faire aux yeux de tous.
        </p>
      </div>
    </div>
  );
};